/**
 * 配送日時指定アプリで配送モーダルが表示されたときに、
 * カートドロワー（<dialog> トップレイヤー）を閉じてモーダルを前面に表示する
 */
(function () {
  const OVERLAY_SELECTORS = ['.delivery-modal__overlay', '[class*="delivery-modal"][class*="overlay"]'];

  function getOverlay() {
    for (let i = 0; i < OVERLAY_SELECTORS.length; i++) {
      const el = document.querySelector(OVERLAY_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function isCartOpen() {
    const dialog = document.querySelector('cart-drawer-component dialog');
    return dialog && dialog.open === true;
  }

  function closeCartDrawer() {
    const cartDrawer = getCartDrawer();
    if (cartDrawer && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    }
  }

  function openCartDrawer() {
    const cartDrawer = getCartDrawer();
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  function isOverlayInDom() {
    return getOverlay() !== null;
  }

  /** オーバーレイが非表示（DOMから削除 or display:none 等）か */
  function isOverlayGone() {
    const overlay = getOverlay();
    if (!overlay) return true;
    const style = window.getComputedStyle(overlay);
    return style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0';
  }

  /** 配送モーダル表示のためこちらでカートを閉じたか */
  let closedCartForOverlay = false;

  function shouldCloseCart() {
    return isOverlayInDom() && isCartOpen();
  }

  function shouldReopenCart() {
    return closedCartForOverlay && isOverlayGone() && !isCartOpen();
  }

  function runCloseCheck() {
    if (shouldCloseCart()) {
      closedCartForOverlay = true;
      closeCartDrawer();
      return;
    }
    if (shouldReopenCart()) {
      closedCartForOverlay = false;
      openCartDrawer();
    }
  }

  const observedOverlays = new WeakSet();

  function observeOverlay(el) {
    if (observedOverlays.has(el)) return;
    observedOverlays.add(el);
    const attrObserver = new MutationObserver(runCloseCheck);
    attrObserver.observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  function startObserving() {
    runCloseCheck();

    const bodyObserver = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length === 0) continue;
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.matches && OVERLAY_SELECTORS.some(function (s) { return node.matches(s); })) {
            runCloseCheck();
            observeOverlay(node);
            return;
          }
          const found = OVERLAY_SELECTORS.reduce(function (acc, s) {
            return acc || (node.querySelector && node.querySelector(s));
          }, null);
          if (found) {
            runCloseCheck();
            observeOverlay(found);
            return;
          }
        }
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });

    OVERLAY_SELECTORS.forEach(function (s) {
      document.querySelectorAll(s).forEach(observeOverlay);
    });

    // アプリの挿入が遅れても検知できるようポーリング
    setInterval(runCloseCheck, 400);
  }

  function init() {
    if (!document.body) {
      requestAnimationFrame(init);
      return;
    }
    if (customElements.get('cart-drawer-component')) {
      startObserving();
    } else {
      customElements.whenDefined('cart-drawer-component').then(startObserving);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
